import { AgentInfo } from '../interfaces/agent';
import { getAgents } from '@/apis/agent';
import { atom } from 'jotai';
import { errorHandler } from '@/utils/request';
import { getAgentId } from '@/utils';

export const agentsDataAtom = atom<AgentInfo[]>([]);
export const agentsMapDataAtom = atom<Record<number, AgentInfo>>({});

export const agentsAtom = atom(
  (get) => ({ agents: get(agentsDataAtom), agentsMap: get(agentsMapDataAtom) }),
  (get, set) =>
    getAgents()
      .then(({ list: agents }) => {
        const agentsMap = agents.reduce(
          (res, agent) => {
            res[agent.id] = agent;
            return res;
          },
          {} as Record<number, AgentInfo>,
        );
        set(agentsDataAtom, agents);
        set(agentsMapDataAtom, agentsMap);
      })
      .catch(errorHandler),
);

export const currentAgentAtom = atom<AgentInfo | undefined>((get) => {
  const { agentsMap } = get(agentsAtom);
  return agentsMap[getAgentId()];
});
